import { InjectionToken } from "@angular/core";

export const AuthHeaders = {
  AUTHORIZATION_HEADER_NAME: 'Authorization',
  ENTERPRISE_DATA_HEADER_NAME: 'X-ENTERPRISE-DATA'
}

export const AuthStorageKeys = {
  ACCESS_TOKEN_KEY: 'accessToken',
  REFRESH_TOKEN_KEY: 'refreshToken',
  TENANT_PROFILE_KEY: 'tenantProfile',
  USER_PROFILE_KEY: 'userProfile',
  LAST_USED_ENTERPRISE_DATA_KEY: 'lastUsedEnterpriseData',
  ANALYTICS_COOKIES_STORAGE_KEY: 'analyticsCookiesPreference',
  ESSENTIAL_COOKIES_STORAGE_KEY: 'essentialCookiesPreference'
}

export const AuthModelFullNames = {
  USER_PROFILE: 'LoginService.UserObjects.Models.User',
}

export const AuthRoutingPaths = {
  LOGIN_ALIAS_PATH: 'login-route',
  CHANGE_PASSWORD_ALIAS_PATH: 'reset-password',
  LOGIN_CHOOSE_TENANT_ALIAS_PATH: 'choose-tenant'
}

export const AuthQueryParams = {
  ACCESS_TOKEN_QUERY_KEY: 'access-token',
  REFRESH_TOKEN_QUERY_KEY: 'refresh-token',
  CLEAR_AUTH_QUERY_KEY: 'clear-auth',
  COMPANY_ID_QUERY_KEY: 'companyId',
  TENANT_ID_QUERY_KEY: 'tenantId',
  ENTERPRISE_ID_QUERY_KEY: 'enterpriseId',
  USER_ID_QUERY_KEY: 'userId',
  ANALYTICS_COOKIES_QUERY_KEY: 'analyticsCookies',
  ESSENTIAL_COOKIES_QUERY_KEY: 'essentialCookies'
}

export const AUTH_MOCK_MODE = new InjectionToken<boolean>('bypass.auth.singleton.check');